import type {
    InventoryResource,
    InventoryResourceType,
} from "@@/shared/acquire/resources/inventory-resource";
import {
    type ResourceDefinition,
    type ResourceDefinitionData,
} from "@@/shared/acquire/resources/resource-definition";
import { isResourceDefinitionOf } from "@@/shared/acquire/resources/resource-definition-helpers";
import {
    type ResourceFoundation,
    type ResourceFoundationData,
} from "@@/shared/acquire/resources/resource-foundation";
import { isResourceFoundationOf } from "@@/shared/acquire/resources/resource-foundation-helpers";
import { type Except } from "type-fest";

type MatchingResourceParts<
    T extends InventoryResource,
    D extends InventoryResourceType = T["_type"],
> = {
    foundation: Except<ResourceFoundation, "data"> & {
        data: ResourceFoundationData<D>;
    };
    definition: Except<ResourceDefinition, "data"> & {
        data: ResourceDefinitionData<D>;
    };
};

const isMatchingResourceParts =
    <T extends InventoryResource>(ofType: T["_type"]) =>
    (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        parts: any,
    ): parts is MatchingResourceParts<T> => {
        return (
            isResourceFoundationOf<T>(ofType)(parts.foundation) &&
            isResourceDefinitionOf<T>(ofType)(parts.definition)
        );
    };

export { isMatchingResourceParts };
export type { MatchingResourceParts };

